import setInboxRules from './setInboxRules';
import store from '../store/store';
import moveDragAndDroppableItem from 'owa-dnd/lib/utils/moveDragAndDroppableItem';
import { action, select } from 'satcheljs/lib/legacy';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export interface MoveInboxRuleState {
    orderedInboxRuleIds: string[];
}

/**
 * Move the inbox rule above the specified node
 * @param ruleIdToMove the rule to be moved
 * @param destinationRuleId the rule to be inserted before
 */
export default action('moveInboxRule')(
    select({
        orderedInboxRuleIds: () => store.inboxRulesListState.inboxRuleIds,
    })(
        createLegacyActionWithDatapoint('moveInboxRuleAction', {
            name: 'TnS_MoveInboxRule',
        })(function moveInboxRule(
            ruleIdToMove: string,
            destinationRuleId: string,
            isDragAndDrop: boolean,
            state?: MoveInboxRuleState
        ): Promise<void> {
            let { orderedInboxRuleIds } = state;

            const fromIndex = orderedInboxRuleIds.indexOf(ruleIdToMove);
            const toIndex = orderedInboxRuleIds.indexOf(destinationRuleId);

            // Move the element from the old position to the new position in the array
            if (isDragAndDrop) {
                moveDragAndDroppableItem(orderedInboxRuleIds, fromIndex, toIndex);
            } else {
                // user has moved the rule using arrow buttons
                const itemToMove = orderedInboxRuleIds.splice(fromIndex, 1)[0];
                orderedInboxRuleIds.splice(toIndex, 0, itemToMove);
            }
            return setInboxRules();
        })
    )
);
